export default __webpack_public_path__ + "static/media/stripe-middle.9ccdcd04.svg";